/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Mission Impact Auth API
 * OpenAPI spec version: v1
 */
export type AcceptAgreementRequestDocumentType =
  (typeof AcceptAgreementRequestDocumentType)[keyof typeof AcceptAgreementRequestDocumentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AcceptAgreementRequestDocumentType = {
  'privacy-policy': 'privacy-policy',
  'terms-of-use': 'terms-of-use',
} as const;

export interface AcceptAgreementRequest {
  documentType: AcceptAgreementRequestDocumentType;
  /** @minLength 1 */
  version: string;
}

export type AccessCheckRequestRequiredRolesItem =
  (typeof AccessCheckRequestRequiredRolesItem)[keyof typeof AccessCheckRequestRequiredRolesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessCheckRequestRequiredRolesItem = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export interface AccessCheckRequest {
  /** @minLength 1 */
  orgId: string;
  requiredRoles: AccessCheckRequestRequiredRolesItem[];
}

export interface AcknowledgeNoticeRequest {
  /** @minLength 1 */
  orgId: string;
}

export interface ActiveNoticeResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  language: string;
  /** @minLength 1 */
  severity: string;
  /** @minLength 1 */
  acknowledgementMode: string;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  summary: string;
  /** @minLength 1 */
  bodyHtml: string;
  /** @minLength 1 */
  startsAt: string;
  /** @nullable */
  endsAt?: string | null;
  acknowledged: boolean;
  /** @nullable */
  acknowledgedAt?: string | null;
}

export type AuditEventItemPayload = { [key: string]: unknown };

export interface AuditEventItem {
  /** @minLength 1 */
  id: string;
  /** @nullable */
  actorUserId?: string | null;
  /** @minLength 1 */
  action: string;
  /** @nullable */
  subjectId?: string | null;
  payload?: AuditEventItemPayload;
  timestampUtc?: string;
}

export interface AuditEventsResponse {
  items: AuditEventItem[];
  continuationToken?: string;
  hasMore?: boolean;
}

export interface AvailableAddOn {
  /** @minLength 1 */
  priceId: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  productName: string;
  description?: string;
  unitAmount: number;
  /** @minLength 1 */
  currency: string;
  /** @minLength 1 */
  interval: string;
  alreadySubscribed: boolean;
  adjustableQuantity: boolean;
  minQuantity: number;
  /** @nullable */
  maxQuantity?: number | null;
}

export interface AvailableAddOnsResponse {
  addOns: AvailableAddOn[];
}

export interface BillingAddressResponse {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
}

export interface BroadcastDryRunResponse {
  totalRecipients?: number;
  users?: BroadcastUserPreview[];
  orgs?: BroadcastOrgPreview[];
}

export type BroadcastFilterDetailResponseFilterType =
  (typeof BroadcastFilterDetailResponseFilterType)[keyof typeof BroadcastFilterDetailResponseFilterType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BroadcastFilterDetailResponseFilterType = {
  All: 'All',
  Ids: 'Ids',
  ProductRegistration: 'ProductRegistration',
  PaidSubscription: 'PaidSubscription',
  BillingCountry: 'BillingCountry',
} as const;

export interface BroadcastFilterDetailResponse {
  id?: string;
  broadcastId?: string;
  filterType?: BroadcastFilterDetailResponseFilterType;
  ids?: string[];
  productIds?: string[];
  countryCodes?: string[];
}

export interface BroadcastFilterResponse {
  filter?: NotificationBroadcastFilter;
}

export interface BroadcastListResponse {
  broadcasts?: BroadcastResponse[];
  totalCount?: number;
}

export interface BroadcastNotificationItem {
  id?: string;
  type?: string;
  targetId?: string;
  status?: string;
  errorMessage?: string;
  createdUtc?: string;
  updatedUtc?: string;
  attempts?: number;
}

export interface BroadcastNotificationsResponse {
  notifications?: BroadcastNotificationItem[];
  totalCount?: number;
  succeededCount?: number;
  failedCount?: number;
  queuedCount?: number;
}

export interface BroadcastOrgPreview {
  orgId?: string;
  name?: string;
}

export type BroadcastResponseStatus =
  (typeof BroadcastResponseStatus)[keyof typeof BroadcastResponseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BroadcastResponseStatus = {
  Draft: 'Draft',
  Queued: 'Queued',
  InProgress: 'InProgress',
  Completed: 'Completed',
  Failed: 'Failed',
} as const;

export type BroadcastResponseRecipientType =
  (typeof BroadcastResponseRecipientType)[keyof typeof BroadcastResponseRecipientType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BroadcastResponseRecipientType = {
  Users: 'Users',
  Orgs: 'Orgs',
  Both: 'Both',
} as const;

export interface BroadcastResponse {
  id?: string;
  name?: string;
  templateId?: string;
  templateEventName?: string;
  status?: BroadcastResponseStatus;
  recipientType?: BroadcastResponseRecipientType;
  createdUtc?: string;
  updatedUtc?: string;
  /** @nullable */
  triggeredUtc?: string | null;
  /** @nullable */
  completedUtc?: string | null;
  /** @nullable */
  totalRecipients?: number | null;
  /** @nullable */
  successCount?: number | null;
  /** @nullable */
  failureCount?: number | null;
  filters?: BroadcastFilterResponse[];
}

export interface BroadcastTriggerResponse {
  broadcastId?: string;
  instanceId?: string;
  message?: string;
}

export interface BroadcastUserPreview {
  userId?: string;
  email?: string;
}

export interface CheckoutResponse {
  /** @minLength 1 */
  checkoutUrl: string;
}

export interface ConsultantHourPackageOffer {
  /** @minLength 1 */
  packageId: string;
  /** @minLength 1 */
  displayName: string;
  hours: number;
  /** @nullable */
  unitAmount?: number | null;
  currency?: string;
}

export interface ConsultantHourPackageOffersResponse {
  packages: ConsultantHourPackageOffer[];
}

export type CreateBroadcastFilterRequestFilterType =
  (typeof CreateBroadcastFilterRequestFilterType)[keyof typeof CreateBroadcastFilterRequestFilterType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBroadcastFilterRequestFilterType = {
  All: 'All',
  Ids: 'Ids',
  ProductRegistration: 'ProductRegistration',
  PaidSubscription: 'PaidSubscription',
  BillingCountry: 'BillingCountry',
} as const;

export interface CreateBroadcastFilterRequest {
  filterType: CreateBroadcastFilterRequestFilterType;
  ids?: string[];
  productIds?: string[];
  countryCodes?: string[];
}

export type CreateBroadcastRequestRecipientType =
  (typeof CreateBroadcastRequestRecipientType)[keyof typeof CreateBroadcastRequestRecipientType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBroadcastRequestRecipientType = {
  Users: 'Users',
  Orgs: 'Orgs',
  Both: 'Both',
} as const;

export interface CreateBroadcastRequest {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  templateId: string;
  recipientType?: CreateBroadcastRequestRecipientType;
}

export interface CreateCheckoutRequest {
  /** @minLength 1 */
  productId: string;
  planId?: string;
  quantity: number;
  /** @minLength 1 */
  successUrl: string;
  /** @minLength 1 */
  cancelUrl: string;
  locale?: string;
}

export interface CreateDefaultEntitlementRequest {
  rule: EntitlementRule;
  /** @nullable */
  durationDays?: number | null;
}

export type CreateInvitationRequestRole =
  (typeof CreateInvitationRequestRole)[keyof typeof CreateInvitationRequestRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateInvitationRequestRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export interface CreateInvitationRequest {
  email?: string;
  role?: CreateInvitationRequestRole;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
}

export interface CreateLegalDocumentVersionRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  version: string;
  /** @minItems 1 */
  links: LegalDocumentLinkItem[];
}

export type CreateNotificationTemplateRequestDefaultMode =
  (typeof CreateNotificationTemplateRequestDefaultMode)[keyof typeof CreateNotificationTemplateRequestDefaultMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNotificationTemplateRequestDefaultMode = {
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  Critical: 'Critical',
} as const;

export interface CreateNotificationTemplateRequest {
  /** @minLength 1 */
  eventName: string;
  isActive: boolean;
  defaultMode?: CreateNotificationTemplateRequestDefaultMode;
}

export interface CreateOrganizationRequest {
  /** @minLength 1 */
  name: string;
  billingCountry?: string;
}

export interface CreatePortalRequest {
  /** @minLength 1 */
  returnUrl: string;
  locale?: string;
}

export interface CreateProductRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  productId: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  displayName: string;
}

export interface CreateProductTrialRequest {
  rule: EntitlementRule;
  /** @nullable */
  durationDays?: number | null;
}

export type CreateRoleRequestRole =
  (typeof CreateRoleRequestRole)[keyof typeof CreateRoleRequestRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateRoleRequestRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export interface CreateRoleRequest {
  /** @nullable */
  userId?: string | null;
  email?: string;
  role: CreateRoleRequestRole;
}

export interface CreateRoleResponse {
  /** @minLength 1 */
  roleId: string;
}

export interface CreateStripePriceEntitlementRequest {
  /** @minLength 1 */
  stripePriceId: string;
  /** @minLength 1 */
  stripeProductId: string;
  entitlementRule: EntitlementRule;
  basePriceId?: string;
  adjustableQuantity?: boolean;
  minQuantity?: number;
  /** @nullable */
  maxQuantity?: number | null;
}

export interface CreateSystemNoticeRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  productId: string;
  /** @minLength 1 */
  severity: string;
  /** @minLength 1 */
  acknowledgementMode: string;
  /** @minLength 1 */
  startsAt: string;
  /** @nullable */
  endsAt?: string | null;
  /** @minLength 1 */
  status: string;
  /** @minItems 1 */
  contents: SystemNoticeContentRequest[];
}

export interface DefaultEntitlementResponse {
  productId?: string;
  rule?: EntitlementRule;
  /** @nullable */
  durationDays?: number | null;
}

export interface DeviceRegistrationRequest {
  /** @minLength 1 */
  deviceId: string;
  /** @minLength 1 */
  deviceName: string;
}

export interface DeviceRegistrationResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  deviceIdHash: string;
  /** @minLength 1 */
  firstSeenUtc: string;
}

/**
 * @nullable
 */
export type EntitlementDetailSubscriptionStatus =
  | (typeof EntitlementDetailSubscriptionStatus)[keyof typeof EntitlementDetailSubscriptionStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitlementDetailSubscriptionStatus = {
  active: 'active',
  past_due: 'past_due',
  unpaid: 'unpaid',
  canceled: 'canceled',
  incomplete: 'incomplete',
} as const;

export interface EntitlementDetail {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  ruleType: string;
  value: number;
  isTrial: boolean;
  isDefault: boolean;
  isSubscription: boolean;
  /** @nullable */
  subscriptionStatus?: EntitlementDetailSubscriptionStatus;
  /** @nullable */
  subscriptionAutoRenews?: boolean | null;
  /** @nullable */
  startDate?: string | null;
  /** @nullable */
  expirationDate?: string | null;
}

export interface EntitlementRule {
  [key: string]: unknown;
}

export interface GetBillingResponse {
  hasBillingAccount: boolean;
  currency?: string;
  address?: BillingAddressResponse;
  defaultPaymentMethod?: PaymentMethodResponse;
}

export interface GetSubscriptionResponse {
  /** @minLength 1 */
  subscriptionId: string;
  /** @minLength 1 */
  status: string;
  items: SubscriptionLineItemResponse[];
  /** @minLength 1 */
  currency: string;
  total: number;
  hasPendingChanges: boolean;
  /** @nullable */
  pendingChangesEffectiveDate?: string | null;
  cancelAtPeriodEnd: boolean;
}

export interface InvitationResponse {
  id?: string;
  /** @nullable */
  userId?: string | null;
  email?: string;
  organizationId?: string;
  role?: string;
  invitationState?: string;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
}

export type InvoiceItemStatus = (typeof InvoiceItemStatus)[keyof typeof InvoiceItemStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceItemStatus = {
  Draft: 'Draft',
  Open: 'Open',
  Paid: 'Paid',
  Uncollectible: 'Uncollectible',
  Void: 'Void',
} as const;

export interface InvoiceItem {
  /** @minLength 1 */
  invoiceId: string;
  amount: number;
  /** @minLength 1 */
  currency: string;
  status: InvoiceItemStatus;
  /** @minLength 1 */
  createdAt: string;
  /** @nullable */
  paidAt?: string | null;
  hostedInvoiceUrl?: string;
  invoicePdfUrl?: string;
}

export interface InvoicesListResponse {
  items: InvoiceItem[];
  totalCount: number;
  page: number;
  pageSize: number;
  hasMore: boolean;
}

export interface LanguageResponse {
  /** @minLength 1 */
  code: string;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  nativeName: string;
}

export interface LegalDocumentLinkItem {
  /**
   * @minLength 2
   * @maxLength 10
   */
  language: string;
  /** @minLength 1 */
  url: string;
}

export interface LegalDocumentLinkResponse {
  id?: string;
  language?: string;
  url?: string;
}

export interface LegalDocumentsListResponse {
  privacyPolicy?: LegalDocumentSummary;
  termsOfUse?: LegalDocumentSummary;
}

export interface LegalDocumentSummary {
  activeVersion?: string;
  versions?: LegalDocumentVersionResponse[];
}

export interface LegalDocumentVersionListResponse {
  versions?: LegalDocumentVersionResponse[];
}

export interface LegalDocumentVersionResponse {
  id?: string;
  documentType?: string;
  version?: string;
  isActive?: boolean;
  createdUtc?: string;
  links?: LegalDocumentLinkResponse[];
}

export type NotificationBroadcastStatus =
  (typeof NotificationBroadcastStatus)[keyof typeof NotificationBroadcastStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationBroadcastStatus = {
  Draft: 'Draft',
  Queued: 'Queued',
  InProgress: 'InProgress',
  Completed: 'Completed',
  Failed: 'Failed',
} as const;

export type NotificationBroadcastRecipientType =
  (typeof NotificationBroadcastRecipientType)[keyof typeof NotificationBroadcastRecipientType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationBroadcastRecipientType = {
  Users: 'Users',
  Orgs: 'Orgs',
  Both: 'Both',
} as const;

export interface NotificationBroadcast {
  id?: string;
  name?: string;
  templateId?: string;
  status?: NotificationBroadcastStatus;
  recipientType?: NotificationBroadcastRecipientType;
  createdBy?: string;
  createdUtc?: string;
  updatedUtc?: string;
  /** @nullable */
  triggeredBy?: string | null;
  /** @nullable */
  triggeredUtc?: string | null;
  /** @nullable */
  completedUtc?: string | null;
  /** @nullable */
  totalRecipients?: number | null;
  /** @nullable */
  successCount?: number | null;
  /** @nullable */
  failureCount?: number | null;
  orchestrationInstanceId?: string;
  template?: NotificationTemplate;
  filters?: NotificationBroadcastFilter[];
}

export interface NotificationBroadcastFilter {
  id?: string;
  notificationBroadcastId?: string;
  notificationBroadcast?: NotificationBroadcast;
}

export type NotificationEventData = { [key: string]: { [key: string]: unknown } };

export interface NotificationEvent {
  id?: string;
  /** @minLength 1 */
  eventName: string;
  timestamp?: string;
  productId?: string;
  data?: NotificationEventData;
}

export interface NotificationSettingItem {
  eventName?: string;
  isEnabled?: boolean;
}

export interface NotificationSettingsResponse {
  settings?: NotificationSettingItem[];
}

export interface NotificationSettingUpdateItem {
  /** @minLength 1 */
  eventName: string;
  isEnabled: boolean;
}

export type NotificationTemplateDefaultMode =
  (typeof NotificationTemplateDefaultMode)[keyof typeof NotificationTemplateDefaultMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationTemplateDefaultMode = {
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  Critical: 'Critical',
} as const;

export interface NotificationTemplate {
  id?: string;
  eventName?: string;
  isActive?: boolean;
  defaultMode?: NotificationTemplateDefaultMode;
  createdBy?: string;
  updatedBy?: string;
  createdUtc?: string;
  updatedUtc?: string;
  localizations?: NotificationTemplateLocalization[];
}

export interface NotificationTemplateListResponse {
  templates: NotificationTemplateResponse[];
}

export type NotificationTemplateLocalizationLanguage =
  (typeof NotificationTemplateLocalizationLanguage)[keyof typeof NotificationTemplateLocalizationLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationTemplateLocalizationLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

export interface NotificationTemplateLocalization {
  id?: string;
  templateId?: string;
  language?: NotificationTemplateLocalizationLanguage;
  subject?: string;
  htmlBody?: string;
  lastEditedBy?: string;
  lastEditedUtc?: string;
  template?: NotificationTemplate;
}

export type NotificationTemplateLocalizationResponseLanguage =
  (typeof NotificationTemplateLocalizationResponseLanguage)[keyof typeof NotificationTemplateLocalizationResponseLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationTemplateLocalizationResponseLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

export interface NotificationTemplateLocalizationResponse {
  /** @minLength 1 */
  id: string;
  language: NotificationTemplateLocalizationResponseLanguage;
  /** @minLength 1 */
  subject: string;
  /** @minLength 1 */
  htmlBody: string;
  /** @minLength 1 */
  lastEditedUtc: string;
}

export type NotificationTemplateResponseDefaultMode =
  (typeof NotificationTemplateResponseDefaultMode)[keyof typeof NotificationTemplateResponseDefaultMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationTemplateResponseDefaultMode = {
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  Critical: 'Critical',
} as const;

export interface NotificationTemplateResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  eventName: string;
  isActive: boolean;
  defaultMode: NotificationTemplateResponseDefaultMode;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
  localizations: NotificationTemplateLocalizationResponse[];
}

export type OrganizationMembershipRole =
  (typeof OrganizationMembershipRole)[keyof typeof OrganizationMembershipRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationMembershipRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export type OrganizationMembershipInvitationState =
  (typeof OrganizationMembershipInvitationState)[keyof typeof OrganizationMembershipInvitationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationMembershipInvitationState = {
  Accepted: 'Accepted',
  Invited: 'Invited',
  Declined: 'Declined',
} as const;

export interface OrganizationMembership {
  /** @minLength 1 */
  orgId: string;
  /** @minLength 1 */
  orgName: string;
  role: OrganizationMembershipRole;
  invitationState: OrganizationMembershipInvitationState;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
}

export interface OrganizationResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
  billingCountry?: string;
  /** @nullable */
  sourcePartnerId?: string | null;
  /** @nullable */
  currentPartnerId?: string | null;
  consultantHoursAssigned: number;
  consultantHoursSpent: number;
  consultantHoursAvailable: number;
}

export interface PaymentMethodResponse {
  type?: string;
  cardBrand?: string;
  cardLast4?: string;
  /** @nullable */
  cardExpMonth?: number | null;
  /** @nullable */
  cardExpYear?: number | null;
}

export type PendingAgreementDocumentType =
  (typeof PendingAgreementDocumentType)[keyof typeof PendingAgreementDocumentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PendingAgreementDocumentType = {
  'privacy-policy': 'privacy-policy',
  'terms-of-use': 'terms-of-use',
} as const;

export interface PendingAgreement {
  documentType?: PendingAgreementDocumentType;
  version?: string;
}

export interface PendingAgreementsResponse {
  pending?: PendingAgreement[];
}

export type PlanResponseScenario = (typeof PlanResponseScenario)[keyof typeof PlanResponseScenario];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanResponseScenario = {
  StandardMonthly: 'StandardMonthly',
  StandardAnnual: 'StandardAnnual',
  NonProfitAnnual: 'NonProfitAnnual',
  PartnerSourcedAnnual: 'PartnerSourcedAnnual',
  PartnerAddOn: 'PartnerAddOn',
} as const;

export interface PlanResponse {
  /** @minLength 1 */
  planId: string;
  scenario: PlanResponseScenario;
  /** @minLength 1 */
  interval: string;
  /** @nullable */
  unitAmount?: number | null;
  /** @nullable */
  currency?: string | null;
  /** @minLength 1 */
  displayName: string;
  isDefault: boolean;
  adjustableQuantity: boolean;
  minQuantity: number;
  /** @nullable */
  maxQuantity?: number | null;
  /** @nullable */
  annualizedUnitAmount?: number | null;
  /** @nullable */
  savingsVsMonthlyBps?: number | null;
}

export interface PortalResponse {
  /** @minLength 1 */
  portalUrl: string;
}

export interface PreviewLineItem {
  /** @minLength 1 */
  priceId: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  productName: string;
  totalAmount: number;
  isProration: boolean;
  /** @nullable */
  quantity?: number | null;
}

export interface PreviewSubscriptionChangeRequest {
  items: ProposedLineItem[];
}

export interface PreviewSubscriptionChangeResponse {
  /** @minLength 1 */
  effectiveDate: string;
  immediateCharge: number;
  newRecurringTotal: number;
  /** @minLength 1 */
  currency: string;
  lineItems: PreviewLineItem[];
}

export type ProblemDetailsExtensions = { [key: string]: { [key: string]: unknown } };

export interface ProblemDetails {
  type?: string;
  title?: string;
  /** @nullable */
  status?: number | null;
  detail?: string;
  instance?: string;
  extensions?: ProblemDetailsExtensions;
}

export interface ProductEntitlementsRollup {
  count: number;
  hasActiveTrial: boolean;
  /** @nullable */
  expiresAt?: string | null;
  isPerpetual: boolean;
  entitlements: EntitlementDetail[];
  jwt?: string;
  isStripeCustomer: boolean;
}

export interface ProductPlansResponse {
  /** @minLength 1 */
  productId: string;
  /** @nullable */
  currency?: string | null;
  plans: PlanResponse[];
}

export interface ProductRegistrationRequest {
  /** @minLength 1 */
  email: string;
}

export interface ProductRegistrationResponse {
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  lastSignedInUtc: string;
  isNewRegistration: boolean;
}

export interface ProductResponse {
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  displayName: string;
  hasDefaultEntitlement: boolean;
  trialsCount: number;
  defaultStripePriceEntitlementId?: string;
  trialReminderDays?: number[];
}

export interface ProductsListResponse {
  products?: ProductResponse[];
}

export interface ProductTrialResponse {
  id?: string;
  productId?: string;
  token?: string;
  rule?: EntitlementRule;
  /** @nullable */
  durationDays?: number | null;
  createdUtc?: string;
  /** @nullable */
  redeemedUtc?: string | null;
}

export interface ProductTrialsListResponse {
  trials?: ProductTrialResponse[];
}

export interface ProposedLineItem {
  /** @minLength 1 */
  priceId: string;
  quantity: number;
}

export interface ProvisionUserRequest {
  /** @minLength 1 */
  email: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  lastName: string;
  /** @maxLength 256 */
  orgName?: string;
}

export interface ProvisionUserResponse {
  userId?: string;
  isNewUser?: boolean;
  /** @nullable */
  orgId?: string | null;
}

export interface RedeemTrialRequest {
  token?: string;
}

export type SendTestNotificationRequestEventData = { [key: string]: { [key: string]: unknown } };

export interface SendTestNotificationRequest {
  /** @minLength 1 */
  eventType: string;
  eventData?: SendTestNotificationRequestEventData;
}

export interface StripeCustomerResponse {
  stripeCustomerId?: string;
  /** @nullable */
  organizationId?: string | null;
  /** @nullable */
  userId?: string | null;
  billingCountry?: string;
  postalCode?: string;
  currency?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface StripeCustomersListResponse {
  items: StripeCustomerResponse[];
  totalCount?: number;
  page?: number;
  pageSize?: number;
  hasMore?: boolean;
}

export interface StripePriceEntitlementResponse {
  /** @minLength 1 */
  stripePriceId: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  stripeProductId: string;
  entitlementRule: EntitlementRule;
  createdAt?: string;
  updatedAt?: string;
  basePriceId?: string;
  adjustableQuantity: boolean;
  minQuantity: number;
  /** @nullable */
  maxQuantity?: number | null;
}

export interface StripePriceEntitlementsListResponse {
  stripePriceEntitlements: StripePriceEntitlementResponse[];
}

export interface StripePriceResponse {
  /** @minLength 1 */
  stripePriceId: string;
  /** @minLength 1 */
  stripeProductId: string;
  active: boolean;
  /** @minLength 1 */
  createdAt: string;
  /** @minLength 1 */
  updatedAt: string;
  hasEntitlementMapping: boolean;
}

export type StripeProductLocalizationResponseLanguage =
  (typeof StripeProductLocalizationResponseLanguage)[keyof typeof StripeProductLocalizationResponseLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripeProductLocalizationResponseLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

export interface StripeProductLocalizationResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  stripeProductId: string;
  language: StripeProductLocalizationResponseLanguage;
  /** @minLength 1 */
  name: string;
  description?: string;
}

export interface StripeProductResponse {
  /** @minLength 1 */
  stripeProductId: string;
  /** @minLength 1 */
  name: string;
  description?: string;
  active: boolean;
  /** @minLength 1 */
  createdAt: string;
  /** @minLength 1 */
  updatedAt: string;
  prices: StripePriceResponse[];
  localizations: StripeProductLocalizationResponse[];
}

export interface StripeProductsListResponse {
  products: StripeProductResponse[];
}

export interface StripeSubscriptionLineItemResponse {
  stripeSubscriptionItemId?: string;
  stripePriceId?: string;
  stripeProductId?: string;
  quantity?: number;
  currentPeriodStart?: string;
  currentPeriodEnd?: string;
}

export interface StripeSubscriptionResponse {
  stripeSubscriptionId?: string;
  stripeCustomerId?: string;
  status?: string;
  cancelAtPeriodEnd?: boolean;
  /** @nullable */
  gracePeriodEndsAt?: string | null;
  currency?: string;
  amount?: number;
  createdAt?: string;
  updatedAt?: string;
  lineItems?: StripeSubscriptionLineItemResponse[];
}

export interface StripeSubscriptionsListResponse {
  items: StripeSubscriptionResponse[];
  totalCount?: number;
  page?: number;
  pageSize?: number;
  hasMore?: boolean;
}

export type StripeSyncOrchestrationStatusOutput = { [key: string]: unknown };

export interface StripeSyncOrchestrationStatus {
  instanceId?: string;
  runtimeStatus?: string;
  syncType?: string;
  /** @nullable */
  createdTime?: string | null;
  /** @nullable */
  lastUpdatedTime?: string | null;
  output?: StripeSyncOrchestrationStatusOutput;
  statusQueryGetUri?: string;
}

export interface StripeSyncResult {
  created?: number;
  updated?: number;
  skipped?: number;
  failed?: number;
  total?: number;
}

export interface SubscriptionLineItemResponse {
  /** @minLength 1 */
  itemId: string;
  /** @minLength 1 */
  priceId: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  productName: string;
  description?: string;
  quantity: number;
  unitAmount: number;
  amount: number;
  isAddOn: boolean;
  canRemove: boolean;
  /** @nullable */
  scheduledQuantity?: number | null;
}

export interface SyncStatusResponse {
  instanceId?: string;
  status?: string;
  createdAt?: string;
  lastUpdatedAt?: string;
  output?: StripeSyncResult;
}

export interface SyncTriggeredResponse {
  instanceId?: string;
  statusQueryUrl?: string;
}

export interface SystemNoticeContentRequest {
  /**
   * @minLength 2
   * @maxLength 10
   */
  language: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  summary: string;
  /** @minLength 1 */
  bodyHtml: string;
}

export interface SystemNoticeContentResponse {
  /** @minLength 1 */
  language: string;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  summary: string;
  /** @minLength 1 */
  bodyHtml: string;
  /** @minLength 1 */
  lastEditedBy: string;
  /** @minLength 1 */
  lastEditedAt: string;
}

export interface SystemNoticeResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  severity: string;
  /** @minLength 1 */
  status: string;
  /** @minLength 1 */
  acknowledgementMode: string;
  /** @minLength 1 */
  startsAt: string;
  /** @nullable */
  endsAt?: string | null;
  /** @minLength 1 */
  createdBy: string;
  /** @minLength 1 */
  updatedBy: string;
  publishedBy?: string;
  /** @minLength 1 */
  createdAt: string;
  /** @minLength 1 */
  updatedAt: string;
  /** @nullable */
  publishedAt?: string | null;
  contents: SystemNoticeContentResponse[];
}

export interface UpdateBroadcastFilterRequest {
  ids?: string[];
  productIds?: string[];
  countryCodes?: string[];
}

/**
 * @nullable
 */
export type UpdateBroadcastRequestRecipientType =
  | (typeof UpdateBroadcastRequestRecipientType)[keyof typeof UpdateBroadcastRequestRecipientType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateBroadcastRequestRecipientType = {
  Users: 'Users',
  Orgs: 'Orgs',
  Both: 'Both',
} as const;

export interface UpdateBroadcastRequest {
  name?: string;
  /** @nullable */
  templateId?: string | null;
  /** @nullable */
  recipientType?: UpdateBroadcastRequestRecipientType;
}

export interface UpdateDefaultEntitlementRequest {
  rule: EntitlementRule;
  /** @nullable */
  durationDays?: number | null;
}

export interface UpdateExternalUserRequest {
  givenName?: string;
  surname?: string;
}

export interface UpdateNotificationSettingsRequest {
  settings: NotificationSettingUpdateItem[];
}

/**
 * @nullable
 */
export type UpdateNotificationTemplateRequestDefaultMode =
  | (typeof UpdateNotificationTemplateRequestDefaultMode)[keyof typeof UpdateNotificationTemplateRequestDefaultMode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateNotificationTemplateRequestDefaultMode = {
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  Critical: 'Critical',
} as const;

export interface UpdateNotificationTemplateRequest {
  /** @nullable */
  isActive?: boolean | null;
  /** @nullable */
  defaultMode?: UpdateNotificationTemplateRequestDefaultMode;
}

export interface UpdateOrganizationRequest {
  /** @minLength 1 */
  name: string;
  billingCountry?: string;
}

export interface UpdateProductRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  displayName?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  defaultStripePriceEntitlementId?: string;
  trialReminderDays?: number[];
}

export type UpdateRoleRequestRole =
  (typeof UpdateRoleRequestRole)[keyof typeof UpdateRoleRequestRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateRoleRequestRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

/**
 * @nullable
 */
export type UpdateRoleRequestInvitationState =
  | (typeof UpdateRoleRequestInvitationState)[keyof typeof UpdateRoleRequestInvitationState]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateRoleRequestInvitationState = {
  Accepted: 'Accepted',
  Invited: 'Invited',
  Declined: 'Declined',
} as const;

export interface UpdateRoleRequest {
  role: UpdateRoleRequestRole;
  /** @nullable */
  invitationState?: UpdateRoleRequestInvitationState;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
}

export interface UpdateStripePriceEntitlementRequest {
  entitlementRule: EntitlementRule;
  adjustableQuantity?: boolean;
  minQuantity?: number;
  /** @nullable */
  maxQuantity?: number | null;
}

export interface UpdateSystemNoticeRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  productId: string;
  /** @minLength 1 */
  severity: string;
  /** @minLength 1 */
  acknowledgementMode: string;
  /** @minLength 1 */
  startsAt: string;
  /** @nullable */
  endsAt?: string | null;
  /** @minLength 1 */
  status: string;
  /** @minItems 1 */
  contents: SystemNoticeContentRequest[];
}

/**
 * @nullable
 */
export type UpdateUserProfileRequestPreferredLanguage =
  | (typeof UpdateUserProfileRequestPreferredLanguage)[keyof typeof UpdateUserProfileRequestPreferredLanguage]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUserProfileRequestPreferredLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

/**
 * @nullable
 */
export type UpdateUserProfileRequestTheme =
  | (typeof UpdateUserProfileRequestTheme)[keyof typeof UpdateUserProfileRequestTheme]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUserProfileRequestTheme = {
  light: 'light',
  dark: 'dark',
  system: 'system',
} as const;

export interface UpdateUserProfileRequest {
  /** @nullable */
  preferredLanguage?: UpdateUserProfileRequestPreferredLanguage;
  /** @nullable */
  theme?: UpdateUserProfileRequestTheme;
  /** @nullable */
  onboarded?: boolean | null;
  billingCountry?: string;
}

export interface UpsertLegalDocumentLinkRequest {
  /**
   * @minLength 2
   * @maxLength 10
   */
  language: string;
  /** @minLength 1 */
  url: string;
}

export type UpsertNotificationTemplateContentRequestLanguage =
  (typeof UpsertNotificationTemplateContentRequestLanguage)[keyof typeof UpsertNotificationTemplateContentRequestLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertNotificationTemplateContentRequestLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

export interface UpsertNotificationTemplateContentRequest {
  language: UpsertNotificationTemplateContentRequestLanguage;
  /** @minLength 1 */
  subject: string;
  /** @minLength 1 */
  htmlBody: string;
}

export type UpsertStripeProductLocalizationRequestLanguage =
  (typeof UpsertStripeProductLocalizationRequestLanguage)[keyof typeof UpsertStripeProductLocalizationRequestLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertStripeProductLocalizationRequestLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

export interface UpsertStripeProductLocalizationRequest {
  language: UpsertStripeProductLocalizationRequestLanguage;
  /** @minLength 1 */
  name: string;
  description?: string;
}

export interface UserAgreementsResponse {
  agreements: UserAgreementStatus[];
}

export type UserAgreementStatusDocumentType =
  (typeof UserAgreementStatusDocumentType)[keyof typeof UserAgreementStatusDocumentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserAgreementStatusDocumentType = {
  'privacy-policy': 'privacy-policy',
  'terms-of-use': 'terms-of-use',
} as const;

export interface UserAgreementStatus {
  documentType: UserAgreementStatusDocumentType;
  acceptedVersion?: string;
  /** @nullable */
  acceptedUtc?: string | null;
  /** @minLength 1 */
  currentVersion: string;
  isUpToDate: boolean;
}

export interface UserOrganizations {
  organizations: OrganizationMembership[];
}

/**
 * @nullable
 */
export type UserProfilePreferredLanguage =
  | (typeof UserProfilePreferredLanguage)[keyof typeof UserProfilePreferredLanguage]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserProfilePreferredLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

/**
 * @nullable
 */
export type UserProfileTheme = (typeof UserProfileTheme)[keyof typeof UserProfileTheme] | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserProfileTheme = {
  light: 'light',
  dark: 'dark',
  system: 'system',
} as const;

export interface UserProfile {
  /** @minLength 1 */
  oid: string;
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  displayName: string;
  /** @minLength 1 */
  status: string;
  /** @nullable */
  preferredLanguage?: UserProfilePreferredLanguage;
  /** @nullable */
  theme?: UserProfileTheme;
  onboarded: boolean;
  billingCountry?: string;
}

export type UserRoleResponseRole = (typeof UserRoleResponseRole)[keyof typeof UserRoleResponseRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserRoleResponseRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export type UserRoleResponseInvitationState =
  (typeof UserRoleResponseInvitationState)[keyof typeof UserRoleResponseInvitationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserRoleResponseInvitationState = {
  Accepted: 'Accepted',
  Invited: 'Invited',
  Declined: 'Declined',
} as const;

export interface UserRoleResponse {
  /** @minLength 1 */
  id: string;
  /** @nullable */
  userId?: string | null;
  email?: string;
  /** @minLength 1 */
  orgId: string;
  role: UserRoleResponseRole;
  invitationState: UserRoleResponseInvitationState;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
}

export interface UserRolesListResponse {
  roles: UserRoleResponse[];
}

export type GetHealth200 = { [key: string]: 0 | 1 };

export type GetHealth500 = { [key: string]: 0 | 1 };

export type GetActiveSystemNoticesParams = {
  /**
   * The product identifier
   */
  productId: string;
  /**
   * Preferred language (defaults to English)
   */
  language?: string;
  /**
   * Organization identifier
   */
  orgId: string;
  /**
   * Include acknowledged notices (default: true)
   */
  includeAcknowledged?: boolean;
  /**
   * Optional evaluation timestamp (defaults to server time) - useful for testing/preview
   */
  now?: string;
};

export type ConsumerGetSystemNoticeParams = {
  /**
   * Preferred language (defaults to English)
   */
  language?: string;
  /**
   * Organization identifier
   */
  orgId: string;
};

export type GetUserProductEntitlementsParams = {
  /**
   * User ID (required for service-to-service requests with Entitlements.Read role)
   */
  userId?: string;
  /**
   * Include signed JWT with entitlement claims (default: false)
   */
  jwt?: boolean;
};

export type GetOrganizationProductEntitlementsParams = {
  /**
   * Include signed JWT with entitlement claims (default: false)
   */
  jwt?: boolean;
};

export type GetOrgInvoicesParams = {
  /**
   * Page number (1-based, default 1)
   */
  page?: number;
  /**
   * Items per page (default 20, max 100)
   */
  pageSize?: number;
};

export interface CreateConsultantHoursCheckoutRequest {
  /** @minLength 1 */
  packageId: string;
  /** @minLength 1 */
  successUrl: string;
  /** @minLength 1 */
  cancelUrl: string;
  locale?: string;
}
